import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { writeRsCmdSettings } from '../../../redux/actions';
import Checkbox from '../../UI/Checkbox/Checkbox';
import Button from '../../UI/Button/Button';
import Modal from '../../UI/Modal/Modal';
import BtnStartStop from './BtnStartStop/BtnStartStop';
import { checkDeviceLink } from '../../Utils/DateFormatter';
import { checkBit, parseBits, stateNA, formatParametr, checkConnectionSlave } from '../../Utils/Functions';
import './RsCommands.css';

export default function RsCommands() {

    const parameter = useSelector((state) => state.dmimei?.data[0]);
    const dispatch = useDispatch();

    const [rsCmd, setRsCmd] = useState([]);
    const [pumpError, setPumpError] = useState();
    const [modal, setModal] = useState(false)   
    const [inputvalue, setInputvalue] = useState();
    const [param, setParam] = useState('');
    const [hasError, setHasError] = useState(false);
    const [checkPidSpeed, setCheckPidSpeed] = useState();  
    const [modePumps, setModePumps] = useState();
    const isConnectionLost = checkConnectionSlave(parameter);
    const browserTime = new Date();
    const islink = checkDeviceLink(parameter?.param_last_date, browserTime);

    const formatPressurePch = (percent, pmax, decimalPlaces = 1, unit = 'Бар') => {
    
        if (percent == null || pmax == null) {
            return '...';
        }
        // Преобразуем в числа, удаляя возможные пробелы
        const percentNum = parseFloat(String(percent).trim());
        const pmaxNum = parseFloat(String(pmax).trim());
        // const pmaxNum = pmax;
        // Проверяем, что оба значения являются корректными числами
        if (isNaN(percentNum) || isNaN(pmaxNum) || pmaxNum <= 0) {
            return '...';
        }
        // Преобразуем "значение с десятыми" в проценты
        const percentValue = percentNum / 10; // 434 -> 43.4
        // Проверяем, что проценты в допустимом диапазоне (0-100%)
        if (percentValue < 0 || percentValue > 100) {
            return '...';
        }
         // Вычисляем давление
        const pressure = pmaxNum * (percentValue / 100);
        return `${pressure.toFixed(decimalPlaces)} ${unit}`;
    };

    const formatSetPressurePch = (pset, pmax) => {
        try {
        if (pset == null || pmax == null)  return '...';
        // Замена запятой на точку и преобразование в число
        const psetNum = Number(String(pset).trim().replace(',', '.'));
        const pmaxNum = Number(String(pmax).trim().replace(',', '.'));
        // Проверяем, что оба значения являются корректными числами
        if (!Number.isFinite(psetNum) || !Number.isFinite(pmaxNum)) return '...';
        if (  pmaxNum <= 0 || psetNum < 0)   return '...';
        // Вычисляем задание давления в процентах
        const psetpersent = (psetNum/pmaxNum) * 1000;
        // Ограничение максимального значения
        const finalResult = Math.min(psetpersent, 1000);
        
        return Math.round(finalResult); // Округление до целого
        } catch (error) {
            return '...';
        }
    }

    const formatSetSpeedPch = (fset, fmax) => {
        try {
            if (fset == null || fmax == null)  return '...';
            const fsetNum = Number(String(fset).trim().replace(',', '.'));
            const fmaxNum = Number(String(fmax).trim().replace(',', '.'));

            if (!Number.isFinite(fsetNum) || !Number.isFinite(fmaxNum)) return '...';
            if (fmaxNum <= 0 || fsetNum < 0) return '...';
            
            const fsetValue = (fsetNum*100 / fmaxNum) * 1000;
            const finalResult = Math.min(fsetValue, 1000);
            return Math.round(finalResult);
        } catch (error) {
            return '...';
        }
    }

    useEffect(() => {
        if (parameter?.typeRsDevice_name=== 'PLC') 
            {   
                setRsCmd ({
                    setPressure: formatParametr(parameter?.param2, 1, 'Бар') || '...',
                    setSpeed: formatParametr(parameter?.param3, 1, 'Гц') || '...',
                })

                const result1 = parseBits(parameter?.param5);
                const state1 = stateNA(result1.bits0to3);

                const result2 = parseBits(parameter?.param8);
                const state2 = stateNA(result2.bits0to3);

                const result3 = parseBits(parameter?.param11);
                const state3 = stateNA(result3.bits0to3);

                const result4 = parseBits(parameter?.param14);
                const state4 = stateNA(result4.bits0to3);

                if (state1==='Авария' || state2==='Авария'|| state3==='Авария'|| state4==='Авария') {
                    setPumpError(true);
                } else {setPumpError(false);}

            }
        if (parameter?.typeRsDevice_name=== 'PCH_Instart' || parameter?.typeRsDevice_name=== 'PCH_ESQ')
            {
                setRsCmd ({
                    setPressure: formatPressurePch(parameter?.param1, parameter?.PMax, 2,'Бар') || '...',
                    setSpeed: formatParametr(parameter?.param9, 2, 'Гц') || '...',
                })
            }

        if (parameter?.typeRsDevice_name=== 'PCH_ATV')
            {
                setRsCmd ({
                    setPressure: formatPressurePch(parameter?.param1, parameter?.PMax, 2,'Бар') || '...',
                    setSpeed: formatParametr(parameter?.param9, 1, 'Гц') || '...',
                })
            }
    },[parameter]);

    useEffect(() => {
        if (parameter?.typeRsDevice_name=== 'PLC') 
            {   if (islink) {
                    if (!isConnectionLost) {
                        if (checkBit(parameter?.param4, 14)) {
                        setCheckPidSpeed(true);
                        setModePumps('pid');
                        } else {
                            setCheckPidSpeed(false);
                            setModePumps('speed');
                        } 
                    } else {setModePumps('inactive');}
              }  else {setModePumps('inactive');}
            }
    },[parameter?.param4, isConnectionLost, islink]);

    useEffect(() => {
          if (islink) {
            if (!isConnectionLost) {
                if (parameter?.typeRsDevice_name=== 'PCH_Instart' || parameter?.typeRsDevice_name=== 'PCH_ESQ')
                    { 
                        if (parameter?.param8=== '8') {setCheckPidSpeed(true); setModePumps('pid');}
                        if (parameter?.param8=== '9') {setCheckPidSpeed(false); setModePumps('speed');}
                    }
                if (parameter?.typeRsDevice_name=== 'PCH_ATV')
                    { 
                        if (parameter?.param8=== '1') {setCheckPidSpeed(true); setModePumps('pid');}
                        if (parameter?.param8=== '0') {setCheckPidSpeed(false); setModePumps('speed');}
                    }
                } else {setModePumps('inactive');}
            }  else {setModePumps('inactive');}
    },[parameter?.param8, isConnectionLost, islink])

    const handleCheckPidSpeed=useCallback((event)=>{ 
    const isChecked = event.target.checked;
     setCheckPidSpeed(isChecked);
     let inputvalue;
     let num;
     if (parameter?.typeRsDevice_name=== 'PLC') {
        num=0;
        if (checkBit(parameter?.param4, 14)) {
            inputvalue=0;}
        else {inputvalue=1}
     }
     if (parameter?.typeRsDevice_name=== 'PCH_Instart' || parameter?.typeRsDevice_name=== 'PCH_ESQ') {
        num=1;
        if (parameter?.param8=== '8') {inputvalue=9} 
        if (parameter?.param8=== '9') {inputvalue=8} 
    }
    if (parameter?.typeRsDevice_name=== 'PCH_ATV') {
        num=1;
        if (parameter?.param8=== '1') {inputvalue=0} 
        if (parameter?.param8=== '0') {inputvalue=1} 
    }
   
     dispatch(writeRsCmdSettings(parameter?.imei, inputvalue, num))
            .then(() => {
                console.log("Данные обновлены");
                alert(`Команда включить режим "${isChecked ? 'По ПИД' : 'по  Скорости'}" отправлена`);
            })
            .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
    },[parameter, dispatch])

    function onClickWinOpen(param) {
        setInputvalue('');
        setParam(param);
        setModal(true);
        setHasError(false);
    }

    function onClicKSave(value) {
        if (!value) {setHasError(true)} else { 
        setHasError(false);
        let inputvalue;
        let num;
        if (param==='Pust') {
            if (parameter?.typeRsDevice_name === 'PLC') {
                num=2; 
                inputvalue=(Math.round(value * 10) / 10)*10;
            }
            if (parameter?.typeRsDevice_name === 'PCH_Instart') {
                num=4;
                inputvalue=formatSetPressurePch(value, parameter?.PMax);
            }
            if (parameter?.typeRsDevice_name === 'PCH_ESQ') {
                num=6;
                inputvalue=formatSetPressurePch(value, parameter?.PMax);
            }
            if (parameter?.typeRsDevice_name === 'PCH_ATV') {
                num=8;
                inputvalue=formatSetPressurePch(value,parameter?.PMax);
            }
        } 
        if (param==='fуст') {
            if (parameter?.typeRsDevice_name === 'PLC') {
                num=3;
                inputvalue=(Math.round(value * 10) / 10)*10; 
            }
            if (parameter?.typeRsDevice_name === 'PCH_Instart') {
                num=5;
                inputvalue=formatSetSpeedPch(value, parameter?.param2);
            }
            if (parameter?.typeRsDevice_name === 'PCH_ESQ') {
                num=7;
                inputvalue=(Math.round(value * 100) / 100)*100;
            }
            if (parameter?.typeRsDevice_name=== 'PCH_ATV') {
                num=9;
                inputvalue=(Math.round(value * 10) / 10)*10;
            }
        }

        dispatch(writeRsCmdSettings(parameter?.imei, inputvalue, num))
        .then(() => {
            console.log("Данные обновлены");
            alert(`Команда на изменение уставки отправлена`);
        })
        .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));

        setModal(false);
        setInputvalue('');  
        }
    }

    function hendleClickDebloked() {
        const num = 10;
        const inputvalue = 32768; //15 бит  
        dispatch(writeRsCmdSettings(parameter?.imei, inputvalue, num))
        .then(() => {
            console.log("Данные обновлены");
            alert ("Команда на деблокировку аварий отправлена");
        })
        .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
    }
    
    return(
        <div className="SettingModeWork">
              <h4 className='SettingModeWorkHeader'>Управление насосной</h4>
             
            <div className='ModePidSpeed'> 
                    <label className={modePumps === 'pid' ? 'mode-active' : 'inactive'}>по ПИД</label>                      
                        <div className='ModeChekbox'>
                            <Checkbox handleCheckboxChange={handleCheckPidSpeed}
                            checked={checkPidSpeed}
                            colorBody='#fff'
                            colorBall='#56579d8c'
                            id="checkbox7" />
                        </div>      
                    <label className={modePumps==='speed' ? 'mode-active' : 'inactive'}>по Скорости</label>  
            </div>
            <div className='SettingPandF'>
                <div className='SettindPapamPlc'> 
                    <lable className='ParamNamePlc'>{parameter?.typeRsDevice_name==='PLC'? ('Pуст:') : ('P:')}</lable>
                    <button onClick={()=>onClickWinOpen('Pust')}
                     className='buttonClickParam'> 
                        <span className='buttonInputPlc'>{islink ? rsCmd.setPressure : '...'}</span>
                    </button>
                </div> 
                <div className='SettindPapamPlc'> 
                    <lable className='ParamNamePlc'>{parameter?.typeRsDevice_name==='PLC'? ('fуст:') : ('f:')}</lable>
                    <button onClick={()=>onClickWinOpen('fуст')}
                    className='buttonClickParam'>
                        <span className='buttonInputPlc'>{islink ? rsCmd.setSpeed : '...'}</span>
                    </button>
                </div> 
            </div>

            {parameter?.typeRsDevice_name === 'PLC' ? (
                (islink && pumpError && !isConnectionLost) ? (<button className='buttonPlcDebloked' 
                onClick={hendleClickDebloked}>Деблокировать аварию</button>) : (null)
            ) : (<BtnStartStop />)}

            <Modal open={modal}>
             <div className='modalHeader'>
                <h3>Введите новое значение</h3>
                <svg  onClick={()=>setModal(false)} height="30" viewBox="0 0 200 200" width="30">    
                    <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                </svg> 
            </div>
            <label className='labelInfo'>Новая уставка {param==='Pust' ? ' P:' : ' f:' } </label>
            <h4 className='labelInfoQuet'>{hasError ? ("Передумали?") : ("Желаете установить "+`${inputvalue}`+'?')}</h4>
            <div className='contentControl'>
                <input type='number' className='input' value={inputvalue} onChange={e=>setInputvalue(e.target.value)}
                style={{border: hasError ? '1px solid red' : null}} />
             <div className='modalButton' >
                        <Button onClick={() => setModal(false)} color="#d2e9d2">Отмена</Button>
                        <Button onClick={()=>onClicKSave(inputvalue)} color="#4bdd4b">Сохранить</Button>
             </div>
             </div>
        </Modal>
        </div>
    )
}